import { StringMap } from '../../types/system';
import {
  currentFolderDefaultState,
  CurrentFolderState,
} from './sub-reducers/current-folder.reducer';
import {
  FilesPaginationState,
  paginationDefaultState,
} from './sub-reducers/pagination.reducer';
import { uiDefaultState, UIState } from './sub-reducers/ui-state.reducer';

export interface SingleFileManagerComponentState {
  currentFolder: CurrentFolderState;
  pagination: FilesPaginationState;
  uiState: UIState;
}

export type FileManagerComponentState =
  StringMap<SingleFileManagerComponentState>;

export const FILE_MANAGER_PAGE_COMPONENT_ID = 'default';

export const defaultFileManagerState: SingleFileManagerComponentState = {
  currentFolder: { ...currentFolderDefaultState },
  pagination: { ...paginationDefaultState },
  uiState: { ...uiDefaultState },
};
